import {UrlLink} from '../../../applink/UrlLink';
import {twMerge} from '../../../common/twMerge';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {CheckBox} from '../CheckBox/CheckBox';
import {CheckProps} from './CheckProps.interface';

/**
 * 체크박스 + 레이블 + 화살표
 * 피그마 : https://www.figma.com/file/lun1D9CzpkoufkINaOHID1/NEXT_Design_System?node-id=5617-72715&t=fBkKViEFOXx4yTfq-4
 */
export function Check({
  checked = false,
  disabled = false,
  label,
  isTitle,
  url,
  onChangeChecked,
  isWebView,
  className,
  ...props
}: CheckProps) {
  return (
    <div
      className={twMerge('flex h-38pxr py-8pxr px-15pxr', className)}
      {...props}
    >
      <label className="flex flex-1 cursor-pointer items-center">
        <CheckBox
          checked={checked}
          disabled={disabled}
          onChange={onChangeChecked}
          className="mr-10pxr h-18pxr w-18pxr"
        />
        <Text
          className={twMerge(
            'flex-1',
            isTitle
              ? 'font-medium1-bold text-theme-solid-100'
              : 'font-small1 text-theme-solid-60'
          )}
        >
          {label}
        </Text>
      </label>
      {url && (
        <UrlLink
          shouldOpenNewWindow={!isWebView}
          url={url}
          windowTitle={label}
          linkClassName="flex"
        >
          <Icon type={IconType.ButtonArrowRight} className="ml-auto" />
        </UrlLink>
      )}
    </div>
  );
}
